import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "80px",
	height: "70px",
	viewBox: "0 0 80 70",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Logo/Large sign" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Logo/Large-sign",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Logo/Large",
				children: [
					/* @__PURE__ */ _jsx("polygon", {
						id: "Fill-35",
						fill: "#0028A0",
						points: "28.8121396 70.0449165 -1.0658141e-14 18.3938088 -1.0658141e-14 70.0449165"
					}),
					/* @__PURE__ */ _jsx("polygon", {
						id: "Fill-36",
						fill: "#0028A0",
						points: "50.9536631 70.0449165 79.9536631 18.3938088 79.9536631 70.0449165"
					}),
					/* @__PURE__ */ _jsx("polyline", {
						id: "Fill-37",
						fill: "#009FDF",
						points: "45.0493475 58.9994537 79.7657056 -1.03508502e-14 61.1042185 -1.03508502e-14 39.8827314 36.8558422 39.8837026 38.3718361 39.8817602 38.3718361 39.8827314 36.8558422 26.0183308 12.2391502 7.3568437 12.2391502 34.7166009 58.9994537"
					})
				]
			})
		})
	]
});
export default SvgLogoCircle;
